import { useState } from 'react';
import { useTranslate } from '@refinedev/core';
import { Button, Tooltip } from 'antd';
import { FlagOutlined } from '@ant-design/icons';
import { PublicationModStatusEditModal } from './PublicationModStatusEditModal';

interface PublicationModStatusEditButtonProps {
  publicationId: number;
  /** Title for the modal until the publication has loaded. */
  title?: string | null;
  /** Small icon-only button for table rows. */
  compact?: boolean;
  onSaved?: () => void;
}

/** Opens the moderation modal of one publication and its formats. */
export const PublicationModStatusEditButton = ({
  publicationId,
  title,
  compact,
  onSaved,
}: PublicationModStatusEditButtonProps) => {
  const t = useTranslate();
  const [open, setOpen] = useState(false);
  const label = t('user_catalog.publications.show.actions.change_mod_status');

  return (
    <>
      {compact ? (
        <Tooltip title={label}>
          <Button
            size="small"
            // Apart from the row's Edit (default) and Delete (danger).
            color="purple"
            variant="outlined"
            icon={<FlagOutlined />}
            aria-label={label}
            onClick={() => setOpen(true)}
          />
        </Tooltip>
      ) : (
        <Button icon={<FlagOutlined />} onClick={() => setOpen(true)}>
          {label}
        </Button>
      )}
      {/* Mounted only while open: every opening loads fresh statuses.
          The modal portals out of a table row, but React still bubbles its
          clicks up the component tree — to the row, which would navigate. */}
      {open && (
        <span onClick={(e) => e.stopPropagation()}>
          <PublicationModStatusEditModal
            publicationId={publicationId}
            title={title}
            open
            onClose={() => setOpen(false)}
            onSaved={onSaved}
          />
        </span>
      )}
    </>
  );
};
